$optimade_zero_search $mol_object
	suggests_uri \https://api.mpds.io/v0/search/selectize
	search_uri \https://api.mpds.io/v0/search/facet
	refinements_uri \https://api.mpds.io/v0/search/refinement
	refinements_extend_param \extd_refine
	-
	param*? \
	separators *
		elements \-
		default \,
	arity *
		unary @ \Unary
		binary @ \Binary
		ternary @ \Ternary
		quaternary @ \Quaternary
	facet *
		aeatoms @ \Polyhedron atoms
		aetypes @ \Polyhedral type
		authors @ \Authors
		classes @ \Materials classes
		codens @ \Journal codes
		doi @ \DOI
		elements @ \Chemical elements
		formulae @ \Chemical formulae
		geos @ \Geography
		lattices @ \Crystal systems
		numeric @ \Numerical search
		orgs @ \Organization
		props @ \Physical properties
		protos @ \Prototypes
		sgs @ \Space groups
		years @ \Years
	examples /
		\thermal expansion AB₂C₄
		\Cr₂FeS₄ monoclinic crystal
		\thermal expansion of HfB₂
		\CeRhIn₅ orthorhombic crystal
		\Cu₃Au tetragonal crystal
		\optical properties ABC
		\paramagnet Mn-Cs
		\pnictogen group, bromide
		\superconductivity AB₂C₃
		\ab initio literature Se-Y
		\phosphate, cubic crystal
		\Zn-Cr-S, orthorhombic crystal
		\metal Sr-Mo
		\thermal expansion for ionic conductors
		\electronic properties for arsenides
